export default __webpack_public_path__ + "static/media/icon-trophy-bronze.1bdf3e42.svg";